export const EMBED_MESSAGE_CHANNEL = 'abrain-opencode-embed';
export const EMBED_MESSAGE_VERSION = 1;

export interface EmbedNavigateCommand {
  channel: typeof EMBED_MESSAGE_CHANNEL;
  version: typeof EMBED_MESSAGE_VERSION;
  type: 'navigate';
  requestId: string;
  sessionId: string;
}

export type EmbedBridgeEvent =
  | {
      channel: typeof EMBED_MESSAGE_CHANNEL;
      version: typeof EMBED_MESSAGE_VERSION;
      type: 'ready';
      sessionId: string;
    }
  | {
      channel: typeof EMBED_MESSAGE_CHANNEL;
      version: typeof EMBED_MESSAGE_VERSION;
      type: 'session-ready';
      requestId: string;
      sessionId: string;
    }
  | {
      channel: typeof EMBED_MESSAGE_CHANNEL;
      version: typeof EMBED_MESSAGE_VERSION;
      type: 'session-error';
      requestId: string;
      sessionId: string;
      error: string;
    }
  | {
      channel: typeof EMBED_MESSAGE_CHANNEL;
      version: typeof EMBED_MESSAGE_VERSION;
      type: 'title-suggested';
      sessionId: string;
      title: string;
    };

function validSessionID(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.length <= 128 &&
    /^ses_[A-Za-z0-9]+$/.test(value)
  );
}

export function parseEmbedBridgeEvent(value: unknown): EmbedBridgeEvent | undefined {
  if (!value || typeof value !== 'object') {
    return undefined;
  }
  const event = value as {
    channel?: unknown;
    version?: unknown;
    type?: unknown;
    requestId?: unknown;
    sessionId?: unknown;
    error?: unknown;
    title?: unknown;
  };
  if (
    event.channel !== EMBED_MESSAGE_CHANNEL ||
    event.version !== EMBED_MESSAGE_VERSION ||
    !validSessionID(event.sessionId)
  ) {
    return undefined;
  }
  if (event.type === 'ready') {
    return event as EmbedBridgeEvent;
  }
  if (
    event.type === 'title-suggested' &&
    typeof event.title === 'string' &&
    event.title.trim().length > 0 &&
    event.title.length <= 100
  ) {
    return event as EmbedBridgeEvent;
  }
  if (
    event.type === 'session-ready' &&
    typeof event.requestId === 'string' &&
    event.requestId.length > 0 &&
    event.requestId.length <= 128
  ) {
    return event as EmbedBridgeEvent;
  }
  if (
    event.type === 'session-error' &&
    typeof event.requestId === 'string' &&
    event.requestId.length > 0 &&
    event.requestId.length <= 128 &&
    typeof event.error === 'string'
  ) {
    return event as EmbedBridgeEvent;
  }
  return undefined;
}

export function embedTargetOrigin(embedUrl: string) {
  try {
    return new URL(embedUrl, window.location.href).origin;
  } catch {
    return undefined;
  }
}
